import { useMutation } from "urql";

import { CreateKycDocument } from "../../../graphql/generated";

interface CreateKYCInput {
  customerId: number;
  ktp_ids: number[];
  npwp_company_id: number;
  npwp_individu_ids?: number[];
  ahu_url?: string;
  nib_url: string;
  newest_akta_url: string;
  pendirian_akta_url?: string;
  passport_urls?: string[];
}

export const useCreateKYC = () => {
  const [result, executeMutation] = useMutation(CreateKycDocument);

  const createKYC = (input: CreateKYCInput) => {
    return executeMutation({
      input: {
        customerId: input.customerId,
        ktp_ids: input.ktp_ids,
        npwp_company_id: input.npwp_company_id,
        npwp_individu_ids: input.npwp_individu_ids,
        nib_url: input.nib_url,
        newest_akta_url: input.newest_akta_url,
        ahu_url: input.ahu_url,
        pendirian_akta_url: input.pendirian_akta_url,
        passport_urls: input.passport_urls,
      },
    });
  };

  return {
    ...result,
    createKYC,
  };
};
